import { vAllProject } from './../../../../../models/extended-models/v-all-project';
import { RolesEnum } from 'src/app/enums/roles-enum';
import { BrowserStorage } from 'src/app/domain/services/browser-storage';
import { Component, OnInit, OnDestroy } from "@angular/core";
import { OptionDetail, Project, vProjectList } from "@app/models";
import { Subscription } from 'rxjs';
import { RoutingKeys, StorageKeys, ToolTipText } from 'src/app/components/shared/constant/commonConstants';
import { Router } from '@angular/router';
import { AppGrid } from 'src/app/domain/app-grid';
import { ModalView } from 'src/app/domain/customize-design/modal';
import { CommonHelperService } from 'src/app/components/shared/common-helpers/helper.service';
import { ConfirmationModalComponent } from 'src/app/components/shared/confirmation-modal/confirmation-modal.component';
import { ApplicationModules, PermissionNames } from 'src/app/enums/application-modules.enum';
import { access } from '@rxweb/angular-router';
import { CustomMessage } from 'src/app/components/shared/constant/custom-message';
import { AbstractHRConsultant } from '../../domain/abstract-hr-consultant';
declare const $: any;

@access({ accessLevel: ApplicationModules.AllProjects, action: PermissionNames.Get })

@Component({
    selector: "app-all-project-list",
    templateUrl: './all-project-list.component.html'
})
export class AllProjectListComponent extends AbstractHRConsultant implements OnInit, OnDestroy {
    subscription: Subscription;
    optionArray: OptionDetail[];
    projectGrid: AppGrid;
    projectGridColumns: any[];
    searchText = '';
    modalView: ModalView;
    roleId: number;
    storage: BrowserStorage;
    isRole: boolean = true;
    constructor(private route: Router,
        private commonHelperService: CommonHelperService) {
        super()
        this.storage = new BrowserStorage();
    }

    ngOnInit(): void {
        this.roleId = this.storage.local.get(StorageKeys.UserRole);
        if (RolesEnum.HRO == this.roleId) {
            this.isRole = false;
        }
        this.initializeGrid();
    }
    initializeGrid() {
        if (!this.commonHelperService.isObjectNullOrUndefined(this.projectGrid)) {
            this.projectGrid.clearGrid('project');
        }
        this.spin = true;
        this.showComponent = true;
        this.subscription = this.get({ queryParams: { 'ListPage': ["listPage"] } }).subscribe((projectList: any) => {
            this.projectGrid = new AppGrid(projectList, vAllProject
                , {
                    actions: {
                        viewDetails: this.viewDetails.bind(this),
                    }
                }
            );
            this.projectGrid.authorization = {
                'get': { accessLevel: ApplicationModules.AllProjects, action: PermissionNames.Get }
            }
            this.projectGrid.design(document.getElementById('project'));
            this.projectGridColumns = this.projectGrid.gridColumns.filter(x => x.keyColumn === false);
            this.projectGrid.search = this.searchText;
            this.spin = false;
            this.addTooltip();
        });
    }


    search(value) {
        this.projectGrid.search = value;
        this.searchText = this.projectGrid.search;
    }

    addTooltip() {
        $(document).ready(function () {
            $(".gridinfobttn").hover(function () {
                $(this).attr("title", ToolTipText.ViewProjectDetails);
            })
        })
    }

    viewDetails(project: any) {
        this.route.navigate([RoutingKeys.HRCProjectDetails, project.projectId]);
    }

    ngOnDestroy(): void {
        if (this.subscription)
            this.subscription.unsubscribe();
    }

}
